"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedERC20Tokens = void 0;
const chains_1 = require("./chains");
/**
 * Returns a list of supported ERC20 tokens
 *
 * @returns List of supported ERC20 tokens
 */
function getSupportedERC20Tokens() {
    return Object.entries(chains_1.supportedNetworks).reduce((acc, [networkName, supportedCurrencies]) => {
        return [
            ...acc,
            ...Object.entries(supportedCurrencies).map(([address, token]) => ({
                address,
                network: networkName,
                decimals: token.decimals,
                symbol: token.symbol,
            })),
        ];
    }, []);
}
exports.getSupportedERC20Tokens = getSupportedERC20Tokens;
